import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import DomainsTable from "../../../components/apps/domains/DomainsTable";
import { useNavigate } from "react-router";

export default function Domains() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Domínios"
                description="Domínios"
            />
            <PageBreadcrumb
                pageTitle="Domínios"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <DomainsTable />
                </div>
            </div>
        </>
    );
}